<template>
  <div :class="[ 'results', 'results__' + personaCalculated ]" :style="styleString">
    <div :class="contentClasses" v-if="personaCalculated === 'economist'">
      <div class="you-are">
        <span>The</span>
      </div>
      <h1>
        Economist
      </h1>
      <p v-if="!resultsComplete">
        By keeping the operations expenses in check, you maximize your company’s margins. Explore quality coffee solutions that satisfy employees all day long without breaking your budget.
      </p>
      <div v-else>
        <!-- <h2>
          Quality coffee that fits the budget.
        </h2> -->
        <p>
          By keeping expenses in check, you maximize your company’s margins. We’ve put together a kit with offers, brands, products and support to help maximize satisfaction and minimize time, waste and other unnecessary costs associated with office coffee.
        </p>
      </div>
    </div>
    <div :class="contentClasses" v-if="personaCalculated === 'never-settler'">
      <div class="you-are">
        <span>The</span>
      </div>
      <h1>
        Never Settler
      </h1>
      <p v-if="!resultsComplete">
        You never settle for less than the best, and the employees in your office love that about you. We’ve gathered premium coffee solutions for you that go above and beyond a caffeine fix, delivering coffee that brightens their days.
      </p>
      <div v-else>
        <!-- <h2>
          Premium office coffee solutions.
        </h2> -->
        <p>
          You never settle for less than the best, and the employees in your office love that about you. We’ve put together a kit with offers, brands, products and support to help you show employees and office visitors how much they matter with every distinct cup.
        </p>
      </div>
    </div>
    <div :class="contentClasses" v-if="personaCalculated === 'busy-bee'">
      <div class="you-are">
        <span>The</span>
      </div>
      <h1>
        Busy Bee
      </h1>
      <p v-if="!resultsComplete">
        You keep a full schedule and need the coffee to worry about itself without letting anyone down. We’ve gathered the most convenient products for an office your size.
      </p>
      <div v-else>
        <!-- <h2>
          Quality coffee that’s easy to manage.
        </h2> -->
        <p>
          You keep a full schedule and need the coffee to worry about itself without letting anyone down. We’ve put together a kit with offers, brands, products and support to help you maximize satisfaction and minimize time spent managing coffee for the office.
        </p>
      </div>
    </div>
    <div v-if="!personaCalculated">
      Error, you skipped a question.
    </div>
    <!-- <div class="results__retake" v-if="resultsComplete">
      <button class="button" type="button" @click="resetQuiz">
        Back to the Quiz
      </button>
    </div> -->
  </div>
</template>

<script>
// import axios from 'axios'
import { assetPath } from './../../mixins/assetPath.js'

// import LeadForm from './../Form/LeadForm.vue'

export default {
  name: "QResults",
  components: {
    // LeadForm,
  },
  data() {
    return {
      persona: {
        scores: {
          a: 0,
          b: 0,
          c: 0,
        },
        tieBreaker: ''
      },
      localPersonaCalc: ''
    }
  },
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    results() {
      return this.$store.state.quiz
    },
    personaCalculated() {
      return this.$store.state.results.personaCalculated
    },
    resultsComplete() {
      return this.$store.state.results.complete
    },
    contentClasses() {
      return 'results__content' + (this.resultsComplete ? ' results__content--email-submitted' : '')
    },
    styleString() {
      return `background-image:url(${this.assetPath}results-backgrounds/results-bg--${this.personaCalculated}-desktop_02@2x.jpg), url(${this.assetPath}results-backgrounds/results-bg--${this.personaCalculated}@2x.jpg)`
    }
  },
  watch: {
    initialized(newValue) {
      // console.log('watch')
      if (newValue) {
        this.calculate()
        // console.log('calculating...', this.persona, this.personaCalculated)
      }
    }
  },
  mounted () {
    // console.log('mounted')
    this.calculate()
    // console.log('calculating...', this.persona, this.personaCalculated)
  },
  methods: {
    calculate() {
      // map to letters
      let _a = 0
      let _b = 0
      let _c = 0
      switch (this.results.role) {
        case 'important':
          _a++
          break
        case 'meh':
          _b++
          break
        case 'vital':
          _c++
          break
      }
      switch (this.results.mostImportant) {
        case 'quality':
          _c++
          break
        case 'cost':
          _b++
          break
        case 'convenience':
          _a++
          break
      }
      switch (this.results.drinkFor) {
        case 'caffeine':
          _b++
          break
        case 'taste':
          _a++
          break
        case 'ritual':
          _c++
          break
      }
      this.persona.scores.a = _a
      this.persona.scores.b = _b
      this.persona.scores.c = _c
      switch (this.results.mostImportant) {
        case 'quality':
          this.persona.tieBreaker = "never-settler"
          break;
        case 'cost':
          this.persona.tieBreaker = "economist"
          break;
        case 'convenience':
          this.persona.tieBreaker = "busy-bee"
          break;
        default:
          this.persona.tieBreaker = false
      }
      this.localPersonaCalc = this.calculatePersona()
      this.$store.dispatch('personaUpdateFromCalc', { persona: this.persona, personaCalculated: this.localPersonaCalc })
      if(this.personaCalculated) {
        this.$store.dispatch('completed', true)
        this.$emit('getProducts')
      }
      // eslint-disable-next-line
      if (typeof dataLayer === 'object') {
        // eslint-disable-next-line
        dataLayer.push({
          event: 'genericEvent',
          eventCat: 'OCS Engagement',
          eventAction: 'complete',
          eventLabel: 'Persona Calculated | ' + this.personaCalculated,
        });
      }
    },
    calculatePersona() {
      let _persona = ''
      if (this.persona.scores.a > 1) {
        _persona = "busy-bee"
      } else if (this.persona.scores.b > 1) {
        _persona = "economist"
      } else if (this.persona.scores.c > 1) {
        _persona = "never-settler"
      } else {
        _persona = this.persona.tieBreaker
      }
      return _persona
    },
    resetRC() {
      this.$emit('resetRC')
    },
    executeRC() {
      this.$emit('executeRC')
    },
    // resetQuiz() {
    //   if (typeof dataLayer === 'object') {
    //     // eslint-disable-next-line
    //     dataLayer.push({
    //       event: 'genericEvent',
    //       eventCat: 'OCS Engagement',
    //       eventAction: 'click',
    //       eventLabel: 'Reset Quiz',
    //     });
    //   }
    //   this.$store.dispatch('resetQuiz')
    // }
  },
  mixins: [assetPath]
}
</script>

<style lang="scss">

.question--results {
  // height: 600px;
  // @include breakpoint(large) {
  //   height: 476px;
  // }
}

.results {
  height: 100%;
  background-position: -9000px 0, 50% 50%;
  background-size: cover, cover;
  background-repeat: no-repeat, no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 1em 2em 1em;
  & > div {
    max-width: 590px;
  }
  p {
    font-family: 'Merriweather', serif;
    font-size: 14px;
    line-height: 1.428;
    font-weight: 400;
    color: $text-light;
    strong {
      color: $blue;
    }
  }
  @include breakpoint(large) {
    background-position: 50% 50%, -9000px 0;
  }
}

.results__content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  h1 {
    color: $grayer;
    text-transform: uppercase;
    font-size: 44px;
    font-weight: 900;
    margin: 0 0 0.1em 0;
    line-height: 1;
  }
  h2 {
    color: $blue;
    font-family: $serif;
    font-size: 18px;
    font-weight: 900;
    line-height: 1.111;
    margin: 0.25em 0 0.333em 0;
    text-transform: uppercase;
  }
  p {
    font-weight: 700;
    margin: 0 0 0.75em 0;
  }
  @include breakpoint(large) {
    h1 {
      font-size: 75px;
    }
  }
  border-bottom: 1px solid currentColor;
}
.results__content--email-submitted {
  border-bottom: none;
}

.results__busy-bee {
  // background-image: url($resultsBBMobile);
  @include breakpoint(large) {
    // background-image: url($resultsBBDesktop);
  }
}
.results__economist {
  // background-image: url($resultsEMobile);
  @include breakpoint(large) {
    // background-image: url($resultsEDesktop);
  }
}
.results__never-settler {
  // background-image: url($resultsNSMobile);
  @include breakpoint(large) {
    // background-image: url($resultsNSDesktop);
  }
}

.you-are {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  &::before, &::after {
    content: '';
    display: block;
    background-color: currentColor;
    height: 1px;
    flex: 1 1 30%;
  }
  span {
    margin: 0;
    color: $text-light;
    font-weight: 900;
    text-transform: uppercase;
    font-size: 24px;
    flex: 0 0 auto;
    padding: 0 0.25em;
  }
  @include breakpoint(large) {
    span {
      font-size: 40px;
    }
  }
}

.results__form {
  p {
    font-size: 12px;
    color: $lgrayer;
  }
}

.results__retake {
  button {
    @include button-style;
  }
}

</style>